import graphql__24a81169050aa9ece323 from "./__generated__/ParticipativeModuleResultsFormFieldWordCloud_result.graphql.js";import { graphql, useFragment } from "react-relay";
import { useCallback } from "react";
import HighchartsReact from "highcharts-react-official";
import { useLocation, useNavigate, useParams } from "react-router";

import Highcharts from "../../lib/charts/customHighCharts";
import ParticipativeModuleResultsFormFieldContainer from "./ParticipativeModuleResultsFormFieldContainer";
import { wordCloudChartConfig } from "../../lib/charts/wordCloudChart";
import { useChartOptions } from "../../lib/charts/useChartColors";
import { resolve, useRoutesContext } from "../Routes/RoutesContext";
import { getContributionsAnchorId } from "../Utils/anchorIds";

const ParticipativeModuleResultsFormFieldWordCloud = props => {
  const result = useFragment(
    ParticipativeModuleResultsFormFieldWordCloud_result,
    props.result
  );

  const {
    colors,
    words,
    tooltipMentionsLabel,
    tooltipContributionsLabel,
    participativeModule
  } = result;

  const navigate = useNavigate();
  const location = useLocation();
  const { participativeModuleSlug: currentParticipativeModuleSlugFromParams } =
    useParams();
  const { pathFor } = useRoutesContext();

  // Prevent cross-module navigation: words are clickable only when the current route is a
  // participative module route matching the word cloud's participative module.
  const currentRoute = resolve(location.pathname);
  const currentParticipativeModuleSlug =
    currentParticipativeModuleSlugFromParams ??
    currentRoute?.params?.participativeModuleSlug;

  const isClickable =
    !!pathFor &&
    !!participativeModule?.slug &&
    currentParticipativeModuleSlug === participativeModule.slug;

  const handleWordClick = useCallback(
    word => {
      if (!isClickable || !word) return;

      const urlParams = new URLSearchParams(location.search);
      urlParams.set("search", word);

      const anchorId = getContributionsAnchorId(participativeModule?.slug);

      // For ContributionsDataviz, redirect to search tab since graph/list views
      // don't display contributions directly (only theme bubbles/cards)
      const isContributionsDataviz =
        currentRoute?.name === "datavizGraph" || currentRoute?.name === "datavizList";

      const datavizSearchParams = {
        participativeModuleSlug: participativeModule.slug
      };

      const targetPathname =
        isContributionsDataviz && pathFor
          ? pathFor("datavizSearch", datavizSearchParams)
          : location.pathname;

      navigate({
        pathname: targetPathname,
        search: `?${urlParams.toString()}`,
        ...(anchorId && { hash: `#${anchorId}` })
      });
    },
    [
      isClickable,
      location.pathname,
      location.search,
      navigate,
      participativeModule?.slug,
      currentRoute?.name,
      pathFor
    ]
  );

  const chartOptions = useChartOptions(colors);

  const chartConfig = {
    ...wordCloudChartConfig(
      { series: words || [] },
      {
        tooltipMentionsLabel,
        tooltipContributionsLabel,
        onWordClick: isClickable ? handleWordClick : undefined
      }
    ),
    ...chartOptions
  };

  return (
    <ParticipativeModuleResultsFormFieldContainer {...props} result={result}>
      <HighchartsReact highcharts={Highcharts} options={chartConfig} />
    </ParticipativeModuleResultsFormFieldContainer>
  );
};

const ParticipativeModuleResultsFormFieldWordCloud_result = graphql__24a81169050aa9ece323;

export default ParticipativeModuleResultsFormFieldWordCloud;
